import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const MCErrorMsg = (props) => {
    return (
        <div className='mc-error-msg'>

            <div>
            <div className={'emoji'}>😔</div>
                {props.children}
            </div>

            <br/>

            <span>{props.auxMsg}</span>

            <br/>

            <a href={'/'}>Voltar para a página inicial.</a>
        </div>
    )
}

MCErrorMsg.propTypes = {
    auxMsg : PropTypes.string
}

MCErrorMsg.defaultProps = {
    auxMsg : "Nosso suporte já foi notificado e estamos trabalhando para\n" +
    "            em breve resolver este problema."
}

export default MCErrorMsg



// WEBPACK FOOTER //
// ./src/components/_common/ErrorMsg/index.js